// Auto-generated by deploy-explorer.yml workflow
// Environment: STAGE
// Generated at: 2026-10-21T19:27:28Z

export const environment = {
  // API Configuration - Provisioned by MJ Central
  GRAPHQL_URI: "https://morecheeseorg-more-cheese-stage-mjapi.azurewebsites.net/",
  GRAPHQL_WS_URI: "wss://morecheeseorg-more-cheese-stage-mjapi.azurewebsites.net/",
  REDIRECT_URI: "https://proud-sea-015424e10.4.azurestaticapps.net/",

  // Authentication - Auto-provisioned by MJ Central (Azure AD)
  CLIENT_ID: "a2515482-8b81-4342-9d17-aaa58162be2c",
  TENANT_ID: "FF10ADE7-5D03-40A9-BE28-CB7AB99670B1",
  CLIENT_AUTHORITY: "https://login.microsoftonline.com/FF10ADE7-5D03-40A9-BE28-CB7AB99670B1",
  AUTH_TYPE: 'msal',
  AUTH0_DOMAIN: "",
  AUTH0_CLIENTID: "",

  // MemberJunction Configuration
  MJ_CORE_SCHEMA_NAME: "__mj",
  APPLICATION_NAME: "MemberJunction",
  APPLICATION_INSTANCE: "STAGE",

  // Runtime Configuration
  NODE_ENV: false ? "production" : "development",
  production: false,

  // UI Configuration
  AUTOSAVE_DEBOUNCE_MS: 1200,
  SEARCH_DEBOUNCE_MS: 800,
  MIN_SEARCH_LENGTH: 3
} as const;
